import React from "react";
import Offers from "./sections/Offers";
import FeaturedProperties from "./sections/FeaturedProperties";
import BannerOne from "./sections/BannerOne";
import Tour from "./sections/Tour";
import Blogs from "./sections/Blogs";

const CustomizedSection = ({ Data }) => {
  return (
    <div className=" space-y-16 lg:space-y-24 lg:mt-0 mt-[250px]">
      <Offers />
      <FeaturedProperties />
      <Tour />
      <BannerOne />
      <Blogs />
    </div>
  );
};

export default CustomizedSection;
